import { get, put } from 'redux/shelf/api';
import { success } from 'redux/shelf/actions';
import { createReducer } from 'redux/shelf/reducer';
import { field } from 'redux/shelf';
import session from 'lib/session';

export const actions = {
  getGeneral: get`settings/frontend/widget/general`(field('general')),
  updateGeneral: put`settings/frontend/widget/general`(),

  getSearch: get`settings/frontend/widget/search`(field('search')),
  updateSearch: put`settings/frontend/widget/search`(),

  getAutocomplete: get`settings/frontend/widget/autocomplete`(field('autocomplete')),
  updateAutocomplete: put`settings/frontend/widget/autocomplete`(),

  getRecommendation: get`settings/frontend/widget/recommendation`(field('recommendation')),
  updateRecommendation: put`settings/frontend/widget/recommendation`(),
};

export const reducer = createReducer(actions);
